import React, { createContext, useContext, useState } from 'react';
import { auth, firestore, functions } from '../lib/firebase';
import { fetchSignInMethodsForEmail } from 'firebase/auth';
import { collection, query, where, getDocs, setDoc, doc, getDoc, deleteDoc, writeBatch, serverTimestamp , addDoc } from 'firebase/firestore';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail as firebaseSendPasswordResetEmail } from 'firebase/auth';
import { setCookie, removeCookie, getCookie } from '../utils/cookieUtil';
import { v4 as uuidv4 } from 'uuid';
import { httpsCallable } from "firebase/functions";




export const checkEmailExist = async (email) => {
  try {
    const signInMethods = await fetchSignInMethodsForEmail(auth, email);
    return signInMethods;
  } catch (error) {
    console.error('Error fetching sign-in methods:', error);
    throw error;
  }
};

export const isAdminUser = async (email) => {
  try {
    const adminUsersRef = collection(firestore, 'AdminUsers');
    const q = query(adminUsersRef, where('email', '==', email));
    const snapshot = await getDocs(q);
    return !snapshot.empty;
  } catch (error) {
    console.error('Error checking admin user:', error);
    throw new Error('Error checking admin user');
  }
};

export const getAdminUserDetails = async (email) => {
  try {
    const adminUsersRef = collection(firestore, 'AdminUsers');
    const q = query(adminUsersRef, where('email', '==', email));
    const snapshot = await getDocs(q);

    if (snapshot.empty) {
      throw new Error('Admin user not found');
    }

    const userDoc = snapshot.docs[0].data();
    return {
      firstName: userDoc.firstName,
      lastName: userDoc.lastName,
      roleId: userDoc.roleId,
      email: userDoc.email,
      role: userDoc.role
    };
  } catch (error) {
    console.error('Error getting admin user details:', error);
    throw new Error('Error getting admin user details');
  }
};


const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(getCookie('user') || null);

  const logoutUser = async () => {
    try {
      console.log("Starting logout process...");
      const timestamp = new Date();
      // const date = timestamp.toISOString().split('T')[0]; // "YYYY-MM-DD"
      // const time = timestamp.toISOString().split('T')[1].split('.')[0];
      console.log("date time", timestamp);

      const user = getCookie('user');
      const randomId = uuidv4();
      await addDoc(collection(firestore, 'Audit Trail'), {
        Action: "Logged Out",
        // Date: date,         // e.g., "2025-05-20"
        // Time: time,         // e.g., "14:32:45"
        timestamp:  new Date().toISOString(),        
        User: `${user.firstName} ${user.lastName}`,
        Platform: "PORTAL"
      });
      removeCookie('user');
      setUser(null);
      console.log("User cookie removed.");

      await auth.signOut();
      console.log("User signed out successfully.");

      window.location.reload();
    } catch (error) {
      console.error('Error logging out:', error);
      throw new Error('Logout failed');
    }
  };

  return (
    <UserContext.Provider value={{ user, setUser, logoutUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);


export const loginUser = async (email, password, navigate) => {
  try {
    const isAdmin = await isAdminUser(email);
    if (isAdmin) {
      await signInWithEmailAndPassword(auth, email, password);

      const userDetails = await getAdminUserDetails(email);
      if (userDetails) {

        setCookie('user', userDetails);
        const roleId = userDetails.roleId;
        try {
          const rolesRef = collection(firestore, 'roles');
          const q = query(rolesRef, where('roleId', '==', roleId));
          const snapshot = await getDocs(q);

          if (snapshot.empty) {
            throw new Error('Admin user not found');
          }

          const userDoc = snapshot.docs[0].data();
          setCookie('roleId', userDoc.permissionList);


        } catch (error) {
          console.error('Error getting admin user details:', error);
          throw new Error('Error getting admin user details');
        }
        const timestamp = new Date();
        // const date = timestamp.toISOString().split('T')[0]; // "YYYY-MM-DD"
        // const time = timestamp.toTimeString().split(' ')[0]; // "HH:MM:SS"
        console.log("date time", timestamp);

        const user = getCookie('user');
        await addDoc(collection(firestore, 'Audit Trail'), {
          Action: "Logged In",
          // Date: date,         // e.g., "2025-05-20"
          // Time: time,         // e.g., "14:32:45"
            timestamp:  new Date().toISOString(),
          User:`${user.firstName} ${user.lastName}`,
          Platform: "PORTAL"
        });
        navigate('/app');
        window.location.reload()
      }

    } else {
      throw new Error('User is not an admin');
    }
  } catch (error) {
    console.error('Error logging in:', error);
    throw new Error('Login failed');
  }
};

export const createAdminUser = async (email, password, firstName, lastName) => {
  try {
    const timestamp = new Date();
    // const date = timestamp.toISOString().split('T')[0]; // "YYYY-MM-DD"
    // const time = timestamp.toTimeString().split(' ')[0]; // "HH:MM:SS"
    var appgroup = null;

    const userExistsInAuth = await checkEmailExist(email);

    if (userExistsInAuth.length === 0) {

      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const UsersListRef = collection(firestore, 'UsersList');
      const emailQuery = query(UsersListRef, where('email', '==', email));
      const querySnapshot = await getDocs(emailQuery);

      if (querySnapshot.empty) {

        await setDoc(doc(firestore, 'AdminUsers', user.uid), {
          userId: user.uid,
          email,
          firstName,
          lastName,
          password,
          role: "Admin",
          roleId: "1AZhOiCk2sQ8cZcWy0iu",
          // Date: date,         // e.g., "2025-05-20"
          // Time: time,         // e.g., "14:32:45"
          timestamp:  new Date().toISOString(),
        });
       
        const loggedInUser = getCookie('user');
      
        await addDoc(collection(firestore, 'Audit Trail'), {
          Action: "Created Admin",
          // Date: date,         // e.g., "2025-05-20"
          // Time: time,
          timestamp:  new Date().toISOString(),
          Admin: `${loggedInUser.firstName} ${loggedInUser.lastName}`,
          User: `${firstName} ${lastName}`,
          Platform: "PORTAL"
        });

        return { success: true, userId: user.uid, newUser: true };

      } else {

        querySnapshot.forEach((doc) => {
          appgroup = doc.data().group;

        });

        await setDoc(doc(firestore, 'AdminUsers', user.uid), {
          userId: user.uid,
          email,
          firstName,
          lastName,
          password,
          role: "Admin",
          roleId: "1AZhOiCk2sQ8cZcWy0iu",
          // Date: date,
          // Time: time,
            timestamp:  new Date().toISOString(),
        });

        await setDoc(doc(firestore, 'Users', user.uid), {
          email: email,
          group: appgroup,
          name: {
            firstName: firstName,
            secondName: lastName
          },
          temp_password_changed: true,
          uid: user.uid,
          timestamp:  new Date().toISOString(),
        });
    

        const loggedInUser = getCookie('user');
    
        await addDoc(collection(firestore, 'Audit Trail'), {
          Action: "Created Admin",
          // Date: date,         // e.g., "2025-05-20"
          // Time: time,
            timestamp:  new Date().toISOString(),
          Admin: `${loggedInUser.firstName} ${loggedInUser.lastName}`,
          User: `${firstName} ${lastName}`,
          Platform: "PORTAL"
        });

        await addDoc(collection(firestore, 'Audit Trail'), {
          Action: "Created Participant",
          // Date: date,         // e.g., "2025-05-20"
          // Time: time,
            timestamp:  new Date().toISOString(),
          Admin: `${loggedInUser.firstName} ${loggedInUser.lastName}`,
          User: `${firstName} ${lastName}`,
          Platform: "PORTAL"
        });

        return { success: true, userId: user.uid, newUser: true };
      }

    } else {

      const adminUsersRef = collection(firestore, 'AdminUsers');
      const emailQuery = query(adminUsersRef, where('email', '==', email));
      const querySnapshot = await getDocs(emailQuery);

      if (querySnapshot.empty) {

        const usersRef = collection(firestore, 'Users');
        const userQuery = query(usersRef, where('email', '==', email));
        const userSnapshot = await getDocs(userQuery);

        if (userSnapshot.empty) {
          throw new Error(`User Already Exists in Administration: ${email}`);
        }

        const userDoc = userSnapshot.docs[0];
        const uid = userDoc.data().uid; // Assumes 'uid' is a field in the document

        // Step 2: Create Admin user using UID
        await setDoc(doc(firestore, 'AdminUsers', uid), {
          userId: uid,
          email,
          firstName,
          lastName,
          role: "Admin",
          roleId: "1AZhOiCk2sQ8cZcWy0iu",
          // Date: date,
          // Time: time,
            timestamp:  new Date().toISOString(),
        });
   
      
        const loggedInUser = getCookie('user');
        await addDoc(collection(firestore, 'Audit Trail'), {
          Action: "Created Admin",
          // Date: date,         // e.g., "2025-05-20"
          // Time: time,
          timestamp:  new Date().toISOString(),
          Admin: `${loggedInUser.firstName} ${loggedInUser.lastName}`,
          User: `${firstName} ${lastName}`,
          Platform: "PORTAL"
        });
        return { success: true, message: 'User data updated with random ID.', newUser: false };
      } else {
        return { success: false, message: 'User already exists.' };
      }

    }

  } catch (error) {
    return {
      success: false,
      message: error?.message?.includes("auth/quota-exceeded")
        ? "Today's quota for user upload has been reached."
        : error?.message || "An unknown error occurred.",
    };
  }
};

export const createFaculty = async (email, password, firstName, lastName) => {
  try {
    var appgroup = null;

    const userExistsInAuth = await checkEmailExist(email);

    if (userExistsInAuth.length === 0) {

      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;


      const UsersListRef = collection(firestore, 'UsersList');
      const emailQuery = query(UsersListRef, where('email', '==', email));
      const querySnapshot = await getDocs(emailQuery);
      const timestamp = new Date();
      // const date = timestamp.toISOString().split('T')[0]; // "YYYY-MM-DD"
      // const time = timestamp.toTimeString().split(' ')[0]; // "HH:MM:SS"
      

      if (querySnapshot.empty) {

        await setDoc(doc(firestore, 'AdminUsers', user.uid), {
          userId: user.uid,
          email,
          firstName,
          lastName,
          password,
          role: "faculty",
          roleId: "ZZQVXbqjZJVd6V9BNcjq",
          // Date: date,
          // Time: time,
            timestamp:  new Date().toISOString(),
        });

      

        const loggedInUser = getCookie('user');
        await addDoc(collection(firestore, 'Audit Trail'), {
          Action: "Created Faculty",
          // Date: date,         // e.g., "2025-05-20"
          // Time: time,
          timestamp:  new Date().toISOString(),
          Admin: `${loggedInUser.firstName} ${loggedInUser.lastName}`,
          User: `${firstName} ${lastName}`,
          Platform: "PORTAL"
        });

        return { success: true, userId: user.uid, newUser: true };

      } else {
        querySnapshot.forEach((doc) => {
          appgroup = doc.data().group;
        });

        await setDoc(doc(firestore, 'AdminUsers', user.uid), {
          userId: user.uid,
          email,
          firstName,
          lastName,
          password,
          role: "faculty",
          roleId: "ZZQVXbqjZJVd6V9BNcjq",
          // Date: date,
          // Time: time,
          timestamp:  new Date().toISOString(),
        });

        await setDoc(doc(firestore, 'Users', user.uid), {
          email: email,
          group: appgroup,
          name: {
            firstName: firstName,
            secondName: lastName
          },
          temp_password_changed: true,
          uid: user.uid,
          // Date: date,
          // Time: time,
          timestamp:  new Date().toISOString(),
        });

        const loggedInUser = getCookie('user');
        await addDoc(collection(firestore, 'Audit Trail'), {
        Action: "Created Faculty",
        timestamp: new Date().toISOString(),
        Admin: `${loggedInUser.firstName} ${loggedInUser.lastName}`,
        User: `${firstName} ${lastName}`,
        Platform: "PORTAL"
      });

      await addDoc(collection(firestore, 'Audit Trail'), {
        Action: "Created Participant",
        timestamp: new Date().toISOString(),
        Admin: `${loggedInUser.firstName} ${loggedInUser.lastName}`,
        User: `${firstName} ${lastName}`,
        Platform: "PORTAL"
      });

        return { success: true, userId: user.uid, newUser: true };
      }
    } else {

      const adminUsersRef = collection(firestore, 'AdminUsers');
      const emailQuery = query(adminUsersRef, where('email', '==', email));
      const querySnapshot = await getDocs(emailQuery);
      const timestamp = new Date();
      // const date = timestamp.toISOString().split('T')[0]; // "YYYY-MM-DD"
      // const time = timestamp.toTimeString().split(' ')[0]; // "HH:MM:SS"


      if (querySnapshot.empty) {

        const usersRef = collection(firestore, 'Users');
        const userQuery = query(usersRef, where('email', '==', email));
        const userSnapshot = await getDocs(userQuery);

        if (userSnapshot.empty) {
          throw new Error(`User Already Exists in Administration: ${email}`);
        }

        const userDoc = userSnapshot.docs[0];
        const uid = userDoc.data().uid; // Assumes 'uid' is a field in the document

        await setDoc(doc(firestore, 'AdminUsers', uid), {
          userId: uid,
          email,
          firstName,
          lastName,
          role: "faculty",
          roleId: "ZZQVXbqjZJVd6V9BNcjq",
          // Date: date,         // e.g., "2025-05-20"
          // Time: time,         // e.g., "14:32:45"
            timestamp:  new Date().toISOString(),
        });

        const loggedInUser = getCookie('user');
        await addDoc(collection(firestore, 'Audit Trail'), {
          Action: "Created Faculty",
          // Date: date,         // e.g., "2025-05-20"
          // Time: time,
          timestamp:  new Date().toISOString(),
          Admin: `${loggedInUser.firstName} ${loggedInUser.lastName}`,
          User: `${firstName} ${lastName}`,
          Platform: "PORTAL"
        });
        

        return { success: true, message: 'User data updated with random ID.', newUser: false };
      } else {
        return { success: false, message: 'User already exists.' };
      }

    }

  } catch (error) {
    return {
      success: false,
      message: error?.message?.includes("auth/quota-exceeded")
        ? "Today's quota for user upload has been reached."
        : error?.message || "An unknown error occurred.",
    };
  }
};

export const createAppUser = async (email, firstName, secondName, group) => {
  var adminUid = null;
  try {
    console.log("checking if mail exist in auth table");
    const userExistsInAuth = await checkEmailExist(email);
    setTimeout(150)
    console.log("completed checking if mail exist in auth table");
    if (userExistsInAuth.length === 0) {
      console.log("user not exist in auth");
      const UsersListRef = collection(firestore, 'UsersList');
      const emailQuery = query(UsersListRef, where('email', '==', email));
      const querySnapshot = await getDocs(emailQuery);


      if (querySnapshot.empty) {
        console.log("user not exist in firestore");

        const rtnVal = await addDoc(collection(firestore, 'UsersList'), {
          email,
          firstName,
          secondName,
          group
        });
        console.log("setDoc result = ", rtnVal);
        const timestamp = new Date();
        // const date = timestamp.toISOString().split('T')[0]; // "YYYY-MM-DD"
        // const time = timestamp.toTimeString().split(' ')[0]; // "HH:MM:SS"
     

        const user = getCookie('user');
        await addDoc(collection(firestore, 'Audit Trail'), {
          Action: "Invited Participant",
          // Date: date,         // e.g., "2025-05-20"
          // Time: time,
          timestamp:  new Date().toISOString(),
          Admin: `${user.firstName} ${user.lastName}`,
          User: `${firstName} ${secondName}`,
          Platform: "PORTAL"
        });

        return { success: true, message: 'User created successfully.', newUser: true };
      } else {
        return { success: false, message: 'User already exists.' };
      }

    } else {
      const AdminuidRef = collection(firestore, 'AdminUsers');
      const emailQueryuid = query(AdminuidRef, where('email', '==', email));
      const querySnapshotuid = await getDocs(emailQueryuid);

      if (querySnapshotuid.empty) {
        return { success: false, message: 'This user is already signed in' };
      }

      querySnapshotuid.forEach((doc) => {
        adminUid = doc.id
        // setAdminuid(doc.id)
      });



      const UsersListRef = collection(firestore, 'UsersList');
      const emailQuery = query(UsersListRef, where('email', '==', email));
      const querySnapshot = await getDocs(emailQuery);


      if (querySnapshot.empty) {
        await setDoc(doc(firestore, 'UsersList', adminUid), {
          email: email,
          group: group,
          firstName: firstName,
          secondName: secondName,
          timestamp:  new Date().toISOString()
        });

        await setDoc(doc(firestore, 'Users', adminUid), {
          email: email,
          group: group,
          name: {
            firstName: firstName,
            secondName: secondName
          },
          temp_password_changed: true,
          uid: adminUid,
          timestamp:  new Date().toISOString()
        });

        const timestamp = new Date();
        // const date = timestamp.toISOString().split('T')[0]; // "YYYY-MM-DD"
        // const time = timestamp.toTimeString().split(' ')[0]; // "HH:MM:SS"
     
        const user = getCookie('user');
      
        await addDoc(collection(firestore, 'Audit Trail'), {
          Action: "Created Participant",
          // Date: date,
          // Time: time,
          timestamp:  new Date().toISOString(),
          Admin: `${user.firstName} ${user.lastName}`,
          User: `${firstName} ${secondName}`,
          Platform: "PORTAL"
        });
        await addDoc(collection(firestore, 'Audit Trail'), {
          Action: "Invited Participant",
          // Date: date,
          // Time: time,
          timestamp:  new Date().toISOString(),
          Admin: `${user.firstName} ${user.lastName}`,
          User: `${firstName} ${secondName}`,
          Platform: "PORTAL"
        });
        return { success: true, message: 'User created successfully.', newUser: false };
      } else {
        return { success: false, message: 'User already exists.' };
      }

    }

  } catch (error) {
    console.log(error);
    return {
      success: false,
      message: error?.message?.includes("auth/quota-exceeded")
        ? "Today's quota for user upload has been reached."
        : error?.message || "An unknown error occurred.",
    };


  }

};

export const sendPasswordResetEmail = async (email) => {
  try {
    await firebaseSendPasswordResetEmail(auth, email);
    return { success: true };
  } catch (error) {
    console.error('Error sending password reset email:', error);
    return { success: false, error: error.message };
  }
};

export async function getRegisteredUsers() {
  try {
    const snapshot = await getDocs(collection(firestore, 'Users'));
    const users = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));



    return new Response(JSON.stringify({ users }), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    console.log(error);

    return new Response(JSON.stringify({ error: 'Failed to fetch users' }), {
      status: 500,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}

export async function getInvitedUsers() {
  try {
    const snapshot = await getDocs(collection(firestore, 'UsersList'));
    const users = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    return new Response(JSON.stringify({ users }), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    console.log(error);

    return new Response(JSON.stringify({ error: 'Failed to fetch users' }), {
      status: 500,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}

export async function getAdminUsers() {
  try {
    const q = query(collection(firestore, 'AdminUsers'), where('role', '==', 'Admin'));
    const snapshot = await getDocs(q);

    const users = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));

    return new Response(JSON.stringify({ users }), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    console.error('[getFaculty] Error fetching Admin users:', error);

    return new Response(JSON.stringify({ error: 'Failed to fetch users' }), {
      status: 500,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}

export async function getFacultyUsers() {
  try {
    const q = query(collection(firestore, 'AdminUsers'), where('role', '==', 'faculty'));
    const snapshot = await getDocs(q);

    const users = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));

    return new Response(JSON.stringify({ users }), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    console.error('[getFaculty] Error fetching Admin users:', error);

    return new Response(JSON.stringify({ error: 'Failed to fetch users' }), {
      status: 500,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}

// export const confirmDeleteRegisteredUser = async (userId) => {
//    try {
//     // 🔍 Validate input
//     if (typeof userToDelete !== "string" || userToDelete.trim().length === 0) {
//       console.error("❌ Invalid user ID provided:", userToDelete);
//       throw new Error("Invalid user ID. Must be a non-empty string.");
//     }

//     const trimmedUserId = userToDelete.trim();
//     console.log("✅ Deleting user ID:", trimmedUserId);

//     // 🔥 Call Firebase Function to delete user from Firebase Auth
//     const deleteUserFn = httpsCallable(functions, "deleteAuthUser");
//     const result = await deleteUserFn({ userId: trimmedUserId });
//     console.log("✅ User deleted from Firebase Auth:", result.data);
//     const userDocRef = doc(firestore, "Users", userToDelete);
//     const userDocSnap = await getDoc(userDocRef);
//     const inviteduserFirstName = userDocSnap.data().name.firstName;
//     const invitedusersecondName = userDocSnap.data().name.secondName;
//     // const deleteUserFn = httpsCallable(functions, "deleteAuthUser");
//     // await deleteUserFn({ userId });

//     const collectionsToDelete = ["Users", "Goals", "Fresh Start", "Cumulative Balance"];
//     const archiveRef = doc(firestore, "Archive", userToDelete);
//     const archiveData = {}; // Collect everything here

//     // --- Handle single-document collections ---
//     await Promise.all(
//       collectionsToDelete.map(async (collectionName) => {
//         try {
//           const docRef = doc(firestore, collectionName, userToDelete);
//           const docSnap = await getDoc(docRef);

//           if (docSnap.exists()) {
//             archiveData[collectionName] = docSnap.data();
//             await deleteDoc(docRef);
//             console.log(`Archived and deleted from '${collectionName}' for user: ${userToDelete}`);
//           } else {
//             console.log(`[INFO] No document found in '${collectionName}' for user: ${userToDelete}`);
//           }
//         } catch (err) {
//           console.error(`[ERROR] '${collectionName}' deletion failed:`, err);
//         }
//       })
//     );

//     // --- Handle multi-document collections ---
//     const archiveCollectionDocs = async (collectionName) => {
//       const colRef = collection(firestore, collectionName);
//       const q = query(colRef, where("userId", "==", userToDelete));
//       const snapshot = await getDocs(q);

//       if (!snapshot.empty) {
//         archiveData[collectionName] = snapshot.docs.map((doc) => doc.data());

//         const batch = writeBatch(firestore);
//         snapshot.forEach((doc) => batch.delete(doc.ref));
//         await batch.commit();
//         console.log(`[SUCCESS] Archived and deleted ${snapshot.size} from '${collectionName}'`);
//       } else {
//         console.log(`[INFO] No documents found in '${collectionName}' for user: ${userToDelete}`);
//       }
//     };

//     await archiveCollectionDocs("Review");
//     await archiveCollectionDocs("Daily Steps");

//     // --- Add single deletedAt timestamp and archive everything at once ---
//     archiveData["DeletedAt"] = serverTimestamp();
//     await setDoc(archiveRef, archiveData, { merge: true });
//     const timestamp = new Date();
//     const date = timestamp.toISOString().split('T')[0]; // "YYYY-MM-DD"
//     const time = timestamp.toTimeString().split(' ')[0]; // "HH:MM:SS"
//     console.log("date time", date);

//     const user = getCookie('user');
//     const randomId = uuidv4();
//     await setDoc(doc(firestore, 'Audit Trail', randomId), {
//       Action: "Deleted Registered User",
//       Date: date,         // e.g., "2025-05-20"
//       Time: time,         // e.g., "14:32:45"
//       Admin: `${user.firstName} ${user.lastName}`,
//       User: `${inviteduserFirstName} ${invitedusersecondName}`,
//       Platform: "PORTAL"
//     });

//   } catch (error) {
//     console.error("[ERROR] Firestore deletion failed:", {
//       errorCode: error.code,
//       errorMessage: error.message,
//       stack: error.stack,
//     });
//     throw error;
//   }
// };


export const confirmDeleteRegisteredUser = async (userId) => {
  try {
    if (typeof userId !== "string" || userId.trim().length === 0) {
      console.error("❌ Invalid user ID provided:", userId);
      throw new Error("Invalid user ID. Must be a non-empty string.");
    }

    const trimmedUserId = userId.trim();
    console.log("✅ Deleting user ID:", trimmedUserId);

    const usersRef = collection(firestore, "AdminUsers");
    const userQuery = query(usersRef, where("userId", "==", trimmedUserId));
    const userQuerySnapshot = await getDocs(userQuery);

    if (userQuerySnapshot.empty) {
      // ✅ Step 3: Only delete from Auth if userId exists in Users
      const deleteUserFn = httpsCallable(functions, "deleteAuthUser");
      const result = await deleteUserFn({ userId: trimmedUserId });
      console.log("✅ User deleted from Firebase Auth:", result.data);
    } else {
      console.log("⚠️ Skipped deleting from Auth. No user with matching userId found in 'AdminUsers' collection.");
    }

    // 📄 Fetch user data before deletion for logging
    const userDocRef = doc(firestore, "Users", trimmedUserId);
    const userDocSnap = await getDoc(userDocRef);
    const inviteduserFirstName = userDocSnap.data()?.name?.firstName || "Unknown";
    const invitedusersecondName = userDocSnap.data()?.name?.secondName || "Unknown";

    const collectionsToDelete = ["Users", "Goals", "Fresh Start", "Cumulative Balance"];
    const archiveRef = doc(firestore, "Archive", trimmedUserId);
    const archiveData = {}; // Store all data to be archived

    // 🗃️ Archive and delete from single-document collections
    await Promise.all(
      collectionsToDelete.map(async (collectionName) => {
        try {
          const docRef = doc(firestore, collectionName, trimmedUserId);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            archiveData[collectionName] = docSnap.data();
            await deleteDoc(docRef);
            console.log(`✅ Archived and deleted from '${collectionName}'`);
          } else {
            console.log(`ℹ️ No document in '${collectionName}' for user: ${trimmedUserId}`);
          }
        } catch (err) {
          console.error(`❌ Error deleting from '${collectionName}':`, err);
        }
      })
    );

    // 🗃️ Archive and delete from multi-document collections
    const archiveCollectionDocs = async (collectionName) => {
      const colRef = collection(firestore, collectionName);
      const q = query(colRef, where("userId", "==", trimmedUserId));
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        archiveData[collectionName] = snapshot.docs.map((doc) => doc.data());

        const batch = writeBatch(firestore);
        snapshot.forEach((doc) => batch.delete(doc.ref));
        await batch.commit();

        console.log(`✅ Archived and deleted ${snapshot.size} docs from '${collectionName}'`);
      } else {
        console.log(`ℹ️ No docs found in '${collectionName}' for user: ${trimmedUserId}`);
      }
    };

    await archiveCollectionDocs("Review");
    await archiveCollectionDocs("Daily Steps");

    // 🕒 Archive timestamp and write archive data
    archiveData["DeletedAt"] = serverTimestamp();
    await setDoc(archiveRef, archiveData, { merge: true });

    // 📝 Audit Trail Entry
    const timestamp = new Date();
    // const date = timestamp.toISOString().split("T")[0]; // YYYY-MM-DD
    // const time = timestamp.toTimeString().split(" ")[0]; // HH:MM:SS

    const user = getCookie("user"); // from your cookie utils
    await addDoc(collection(firestore, "Audit Trail"), {
      Action: "Deleted Registered User",
      // Date: date,
      // Time: time,
      timestamp:  new Date().toISOString(),
      Admin: `${user?.firstName ?? "Unknown"} ${user?.lastName ?? "Unknown"}`,
      User: `${inviteduserFirstName} ${invitedusersecondName}`,
      Platform: "PORTAL",
    });

    console.log("✅ Audit Trail entry created.");

  } catch (error) {
    console.error("🔥 [ERROR] Deletion failed:", {
      code: error.code,
      message: error.message,
      stack: error.stack,
    });
    throw error;
  }
};


export async function getAuditTrail() {
  try {
    const q = query(collection(firestore, 'Audit Trail'));
    const snapshot = await getDocs(q);

    const logs = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));

    return logs;
  } catch (error) {
    console.error('[getAuditTrail] Error fetching audit logs:', error);
    throw new Error('Failed to fetch audit logs');
  }
}


export const confirmDeleteInvitedUser = async (docId) => {
  try {


    if (!docId) {
      throw new Error('Email is missing for deletion');
    }

    // const UsersListCollectionRef = collection(firestore, "UsersList");
    // const UsersListQuery = query(UsersListCollectionRef, where("email", "==", userEmail));

    // const UsersListQuerySnapshot = await getDocs(UsersListQuery);

    // if (!UsersListQuerySnapshot.empty) {
    //   const batch = writeBatch(firestore);
    //   UsersListQuerySnapshot.forEach((doc) => {
    //     batch.delete(doc.ref);
    //   });
    //   await batch.commit();
    //   console.log(`[SUCCESS] Deleted user: ${userEmail}`);
    // } else {
    //   console.log(`[INFO] No user found : ${userEmail}`);
    // }

    const userDocRef = doc(firestore, "UsersList", docId);

    // Then use the reference with getDoc
    const userDocSnap = await getDoc(userDocRef);
    const inviteduserFirstName = userDocSnap.data().firstName;
    const invitedusersecondName = userDocSnap.data().secondName;
    const timestamp = new Date();
    // const date = timestamp.toISOString().split('T')[0]; // "YYYY-MM-DD"
    // const time = timestamp.toTimeString().split(' ')[0]; // "HH:MM:SS"
    
    if (userDocSnap.exists()) {
      await deleteDoc(userDocRef);

      console.log(`[SUCCESS] Deleted user: ${docId}`);
    } else {
      console.log(`[INFO] No user found with ID: ${docId}`);
    }

    const user = getCookie('user');
    await addDoc(collection(firestore, 'Audit Trail'), {
      Action: "Deleted Invited User",
      // Date: date,         // e.g., "2025-05-20"
      // Time: time,
      timestamp:  new Date().toISOString(),
      Admin: `${user.firstName} ${user.lastName}`,
      User: `${inviteduserFirstName} ${invitedusersecondName}`,
      Platform: "PORTAL"
    });

  } catch (error) {
    console.error('[ERROR] Firestore deletion failed:', {
      errorCode: error.code,
      errorMessage: error.message,
      stack: error.stack
    });
    throw error;
  }
};


export const confirmDeleteFacultyUser = async (userToDelete) => {
  try {
    // 🔍 Validate input
    if (typeof userToDelete !== "string" || userToDelete.trim().length === 0) {
      console.error("❌ Invalid user ID provided:", userToDelete);
      throw new Error("Invalid user ID. Must be a non-empty string.");
    }

    const trimmedUserId = userToDelete.trim();
    console.log("✅ Deleting user ID:", trimmedUserId);

    const usersRef = collection(firestore, "Users");
    const userQuery = query(usersRef, where("uid", "==", trimmedUserId));
    const userQuerySnapshot = await getDocs(userQuery);

    if (userQuerySnapshot.empty) {
      // ✅ Step 3: Only delete from Auth if userId exists in Users
      const deleteUserFn = httpsCallable(functions, "deleteAuthUser");
      const result = await deleteUserFn({ userId: trimmedUserId });
      console.log("✅ User deleted from Firebase Auth:", result.data);
    } else {
      console.log("⚠️ Skipped deleting from Auth. No user with matching userId found in 'Users' collection.");
    }

    // 📄 Delete corresponding Firestore document
    const userDocRef = doc(firestore, "AdminUsers", trimmedUserId);
    const userDocSnap = await getDoc(userDocRef);
    // Extract user data
    const userData = userDocSnap.data();
    const FacultyFirstName = userData.firstName || "Unknown";
    const FacultySecondName = userData.lastName || "Unknown";
    if (userDocSnap.exists()) {
      await deleteDoc(userDocRef);
      console.log(`[SUCCESS] Deleted Firestore user document: ${trimmedUserId}`);
      // 🕒 Generate audit log info
      const timestamp = new Date();
      // const date = timestamp.toISOString().split("T")[0]; // YYYY-MM-DD
      // const time = timestamp.toTimeString().split(" ")[0]; // HH:MM:SS

      // 👤 Get current admin user info
      const adminUser = getCookie("user"); // Should return { firstName, lastName }
      const adminName = adminUser
        ? `${adminUser.firstName} ${adminUser.lastName}`
        : "Unknown Admin";

      // 📝 Write to Audit Trail
      await addDoc(collection(firestore, "Audit Trail"), {
        Action: "Deleted Faculty User",
        // Date: date,
        // Time: time,
        timestamp:  new Date().toISOString(),
        Admin: adminName,
        User: `${FacultyFirstName} ${FacultySecondName}`,
        Platform: "PORTAL",
      });

      console.log(`[AUDIT] Logged deletion of user: ${trimmedUserId}`);
    } else {
      console.log(`[INFO] No Firestore user found with ID: ${trimmedUserId}`);
    }
  } catch (error) {
    console.error("[ERROR] Failed to delete user:", {
      errorCode: error.code,
      errorMessage: error.message,
      stack: error.stack,
    });
    throw error;
  }
};


export const confirmDeleteAdminUser = async (userToDelete) => {
  try {
    // 🔍 Validate input
    if (typeof userToDelete !== "string" || userToDelete.trim().length === 0) {
      console.error("❌ Invalid user ID provided:", userToDelete);
      throw new Error("Invalid user ID. Must be a non-empty string.");
    }

    const trimmedUserId = userToDelete.trim();
    console.log("✅ Deleting user ID:", trimmedUserId);

    const usersRef = collection(firestore, "Users");
    const userQuery = query(usersRef, where("uid", "==", trimmedUserId));
    const userQuerySnapshot = await getDocs(userQuery);

    if (userQuerySnapshot.empty) {
      // ✅ Step 3: Only delete from Auth if userId exists in Users
      const deleteUserFn = httpsCallable(functions, "deleteAuthUser");
      const result = await deleteUserFn({ userId: trimmedUserId });
      console.log("✅ User deleted from Firebase Auth:", result.data);
    } else {
      console.log("⚠️ Skipped deleting from Auth. No user with matching userId found in 'Users' collection.");
    }

    // 🔗 Reference to Firestore user doc
    const userDocRef = doc(firestore, "AdminUsers", trimmedUserId);
    const userDocSnap = await getDoc(userDocRef);
    // 📝 Extract user data
    const userData = userDocSnap.data();
    const AdminFirstName = userData.firstName || "Unknown";
    const AdminSecondName = userData.lastName || "Unknown";
    if (userDocSnap.exists()) {
      await deleteDoc(userDocRef);
      console.log(`[SUCCESS] Deleted Firestore user document: ${trimmedUserId}`);

      // 🕒 Prepare timestamp
      const timestamp = new Date();
      // const date = timestamp.toISOString().split("T")[0]; // "YYYY-MM-DD"
      // const time = timestamp.toTimeString().split(" ")[0]; // "HH:MM:SS"

      // 👤 Get current admin (deleting user) info from cookie
      const adminUser = getCookie("user");
      const adminName = adminUser
        ? `${adminUser.firstName} ${adminUser.lastName}`
        : "Unknown Admin";

      // 🗒️ Log Audit Trail
      await addDoc(collection(firestore, "Audit Trail"), {
        Action: "Deleted Admin User",
        // Date: date,
        // Time: time,
        timestamp:  new Date().toISOString(),
        Admin: adminName,
        User: `${AdminFirstName} ${AdminSecondName}`,
        Platform: "PORTAL",
      });

      console.log(`[AUDIT] Logged deletion of user: ${trimmedUserId}`);
    } else {
      console.log(`[INFO] No Firestore user found with ID: ${trimmedUserId}`);
    }
  } catch (error) {
    console.error("[ERROR] Failed to delete user:", {
      errorCode: error.code,
      errorMessage: error.message,
      stack: error.stack,
    });
    throw error;
  }
};

